import InformationCircleIcon from "../../../../icons/informationCirlceIcon";
import NoteIcon from "../../../../icons/noteIcon";
import TickIcon from "../../../../icons/tickIcon";
import XIcon from "../../../../icons/xIcon";
import { mode } from "../../../../utils";

const showRequest = ({ t, selected }) => {
  return (
    <div className="space-y-2 text-black dark:text-white">
      <h2 className="font-semibold">{t("shipmentDetails")}</h2>
      <section className="bg-[#F2F4F6] dark:bg-gray-800 rounded-lg p-4">
        <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("requestType")}</p>
            <p className="my-2 font-medium">{selected?.orderType}</p>
          </div>
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("customerName")}</p>
            <p className="my-2 font-medium">{selected?.customerName}</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("date")}</p>
            <p className="my-2 font-medium">{selected?.date}</p>
          </div>
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("status")}</p>
            <p className="my-2 text-mainBlue dark:text-blue-400">{selected?.status}</p>
          </div>
        </div>
      </section>

      <h2 className="font-semibold">{t("requestDescription")}</h2>
      <section className="bg-[#F2F4F6] dark:bg-gray-800 rounded-lg p-4">
        <p>
          أود إصدار بوليصة شحن لطرد سيتم إرساله من القاهرة إلى الرياض. الطرد يحتوي على
          منتجات إلكترونية بقيمة 5000 ريال.
        </p>
      </section>

      <h2 className="font-semibold">{t("attachments")}</h2>
      <section className="bg-[#F2F4F6] dark:bg-gray-800 rounded-lg p-4">
        <p className="flex items-center gap-2">
          <NoteIcon fill={mode === "dark" ? "white" : ""} />
          <span>فاتورة الشراء.pdf</span>
        </p>
        <p className="flex items-center gap-2">
          <NoteIcon fill={mode === "dark" ? "white" : ""} />
          <span>صورة المنتج.jpg</span>
        </p>
      </section>

      <h2 className="font-semibold">{t("actions")}</h2>
      <div className="flex items-center gap-2">
        <button className="bg-[#16A34A] text-white flex items-center gap-1 py-2 px-2 rounded-[10px] capitalize">
          <TickIcon />
          {t("proceed")}
        </button>
        <button className="bg-mainRed text-white flex items-center gap-1 py-2 px-2 rounded-[10px] capitalize">
          <XIcon />
          {t("reject")}
        </button>
        <button className="bg-white dark:bg-gray-700 border border-black dark:border-white text-black dark:text-white flex items-center gap-1 py-2 px-2 rounded-[10px] capitalize">
          <InformationCircleIcon fill={mode === "dark" ? "white" : ""} />
          {t("pendForReview")}
        </button>
      </div>
    </div>
  );
};

export default showRequest;
